import { ColorPicker, Field, TextInput } from "@carbon6/c6-frontend-design";
import type { ChangeEvent, ReactNode } from "react";

type LabelDetailsFieldsProps = {
  color: number;
  colorFieldId: string;
  description: string;
  disabled: boolean;
  onColorChange: (color: number) => void;
  onDescriptionChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function LabelDetailsFields({
  color,
  colorFieldId,
  description,
  disabled,
  onColorChange,
  onDescriptionChange,
}: LabelDetailsFieldsProps): ReactNode {
  return (
    <>
      <Field id={colorFieldId} label="색상" layout="stack" disabled={disabled}>
        <ColorPicker id={colorFieldId} value={color} disabled={disabled} onChange={onColorChange} />
      </Field>
      <Field label="설명" layout="stack" disabled={disabled}>
        <TextInput value={description} onChange={onDescriptionChange} />
      </Field>
    </>
  );
}
